var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.initial_ids),function(id){return _c('Character',{attrs:{"id":id}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }